module.exports = __webpack_public_path__ + "2a3cc50ad78e6d8824368497a11d4dcd.svg";